const allowedWordsEnlish: string[] = [
  'a', 'aboard', 'about', 'above', 'across', 'after', 'against', 'along',
  'amid', 'among', 'an', 'and', 'around', 'as', 'at', 'because', 'before',
  'behind', 'below', 'beneath', 'beside', 'between', 'beyond', 'but', 'by',
  'concerning', 'considering', 'despite', 'down', 'during', 'except', 'following',
  'for', 'from', 'if', 'in', 'inside', 'into', 'is', 'it', 'like', 'minus', 'near',
  'next', 'of', 'off', 'on', 'onto', 'opposite', 'or', 'out', 'outside', 'over',
  'past', 'per', 'plus', 'regarding', 'round', 'save', 'since', 'than', 'the',
  'through', 'till', 'to', 'toward', 'under', 'underneath', 'unlike', 'until',
  'up', 'upon', 'versus', 'via', 'was', 'with', 'within', 'without',
];

export const allowedWords: Record<string, string[]> = {
  en: allowedWordsEnlish,
};
